import { render, staticRenderFns } from "./TepAutorizacionDetalle.vue?vue&type=template&id=05295ae9"
import script from "./TepAutorizacionDetalle.vue?vue&type=script&lang=js"
export * from "./TepAutorizacionDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports